/* Load and play product rotation videos only while their card image is hovered. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var activeCard = null;
  var pointerX = -1;
  var pointerY = -1;

  function withinImage(card, x, y) {
    var bounds = card.getBoundingClientRect();
    return x >= bounds.left && x < bounds.right && y >= bounds.top && y < bounds.bottom;
  }

  function stop(card) {
    if (activeCard === card) activeCard = null;
    var video = card.querySelector('video');
    if (!video) return;
    card.classList.remove('is-rotation-playing');
    video.pause();
    try { video.currentTime = 0; } catch (error) { /* No loaded frame yet. */ }
  }

  function updatePointer(event) {
    if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    pointerX = event.clientX;
    pointerY = event.clientY;

    // V2 cards have a full-card link overlay above the image. Find their image
    // region through the card, then check the actual pointer position.
    var card = event.target.closest('[data-product-rotation]');
    if (!card) {
      var v2Card = event.target.closest('.mti-v2-card');
      if (v2Card) card = v2Card.querySelector('[data-product-rotation]');
    }
    if (reducedMotion.matches || !card || !withinImage(card, pointerX, pointerY)) {
      if (activeCard) stop(activeCard);
      return;
    }
    if (activeCard === card) return;
    if (activeCard) stop(activeCard);
    var video = card.querySelector('video');
    if (!video) return;
    activeCard = card;
    var playback = video.play();
    if (playback && typeof playback.then === 'function') {
      playback.then(function () {
        if (activeCard === card && withinImage(card, pointerX, pointerY)) card.classList.add('is-rotation-playing');
        else stop(card);
      }).catch(function () { stop(card); });
    } else {
      card.classList.add('is-rotation-playing');
    }
  }

  document.addEventListener('pointerover', updatePointer);
  document.addEventListener('pointermove', updatePointer, { passive: true });
  document.addEventListener('pointerout', function (event) {
    if (!event.relatedTarget && activeCard) stop(activeCard);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && activeCard) stop(activeCard);
  });
  window.addEventListener('blur', function () { if (activeCard) stop(activeCard); });

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', function () {
      if (reducedMotion.matches && activeCard) stop(activeCard);
    });
  }
}());
